import { ShopItem } from '../types';

// Define all available shop items
export const SHOP_ITEMS: ShopItem[] = [
  // XP Boosts
  {
    id: 'xp_boost_small',
    name: 'Hunter\'s Recovery Potion',
    description: '「E-Rank」Basic Hunter Association potion. Grants combat experience from low-rank monsters.',
    icon: '🧪',
    image: '/artifacts/potions/potion_xp_minor.png',
    type: 'xp_boost',
    price: 30,
    effect: { xpMultiplier: 100 },
  },
  {
    id: 'xp_boost_medium',
    name: 'Mana Crystal Elixir',
    description: '「C-Rank」Condensed dungeon core mana. Equivalent to clearing a C-Rank gate.',
    icon: '⚗️',
    image: '/artifacts/potions/potion_xp_medium.png',
    type: 'xp_boost',
    price: 80,
    effect: { xpMultiplier: 250 },
  },
  {
    id: 'xp_boost_large',
    name: 'Essence of the Abyss',
    description: '「A-Rank」High-rank magic beast essence. Power of conquering an entire dungeon.',
    icon: '🍾',
    type: 'xp_boost',
    price: 150,
    effect: { xpMultiplier: 500 },
  },

  // Stat Boosts
  {
    id: 'stat_strength',
    name: 'Titan\'s Blood Vial',
    description: '「B-Rank」Red Gate boss blood. Permanently enhances physical power.',
    icon: '💪',
    image: '/artifacts/potions/elixir_strength.png',
    type: 'stat_boost',
    price: 120,
    effect: { statBoost: { strength: 8 } },
  },
  {
    id: 'stat_intelligence',
    name: 'Grimoire of Ancient Knowledge',
    description: '「B-Rank」Mystical tome of forgotten magic. Expands mana capacity permanently.',
    icon: '📚',
    image: '/artifacts/books/tome_intelligence.png',
    type: 'stat_boost',
    price: 120,
    effect: { statBoost: { intelligence: 8 } },
  },
  {
    id: 'stat_agility',
    name: 'Shadow Dancer\'s Greaves',
    description: '「B-Rank」S-Rank assassin\'s boots. Grants supernatural speed and reflexes.',
    icon: '👟',
    image: '/artifacts/equipment/boots_agility.png',
    type: 'stat_boost',
    price: 120,
    effect: { statBoost: { agility: 8 } },
  },
  {
    id: 'stat_vitality',
    name: 'Phoenix Heart Ring',
    description: '「B-Rank」Mythical beast magic stone. Fortifies body with regenerative vitality.',
    icon: '💍',
    image: '/artifacts/equipment/ring_vitality.png',
    type: 'stat_boost',
    price: 120,
    effect: { statBoost: { vitality: 8 } },
  },
  {
    id: 'stat_sense',
    name: 'Eye of the Oracle',
    description: '「B-Rank」Prophet\'s crystallized eye. Grants heightened perception permanently.',
    icon: '📿',
    image: '/artifacts/equipment/amulet_sense.png',
    type: 'stat_boost',
    price: 120,
    effect: { statBoost: { sense: 8 } },
  },

  // Special Items
  {
    id: 'stat_all',
    name: 'Elixir of Transcendence',
    description: '「S-Rank」Impossibly rare elixir. Triggers complete body reawakening.',
    icon: '✨',
    type: 'special',
    price: 400,
    effect: { 
      statBoost: { 
        strength: 5, 
        intelligence: 5, 
        agility: 5, 
        vitality: 5, 
        sense: 5 
      } 
    },
  },
  {
    id: 'level_up',
    name: 'System Awakening Stone',
    description: '「S-Rank」Resonates with the System. Instantly advances you to the next rank.',
    icon: '⬆️',
    type: 'special',
    price: 600,
    effect: { xpMultiplier: 0 }, // Special handling in code
  },
  {
    id: 'armor_blue',
    name: 'Knight Commander\'s Plate',
    description: '「SS-Rank」Double dungeon legendary armor. Forged to oppose the Monarchs.',
    icon: '🛡️',
    image: '/artifacts/equipment/armor_blue.png',
    type: 'special',
    price: 1000,
    effect: { 
      statBoost: { 
        strength: 12, 
        vitality: 18, 
        sense: 8 
      } 
    },
  },

  // Cosmetics
  {
    id: 'cosmetic_hunter',
    name: 'Association Hunter License',
    description: '「Cosmetic」Official Hunter Association badge. Displays your certified rank.',
    icon: '🎖️',
    image: '/artifacts/cosmetics/badge_hunter.png',
    type: 'cosmetic',
    price: 100,
  },
  {
    id: 'cosmetic_monarch',
    name: 'Shadow Sovereign\'s Crown',
    description: '「National Treasure」Absolute authority over death. Commands armies of shadows.',
    icon: '👑',
    image: '/artifacts/special/crown_shadow_monarch.png',
    type: 'cosmetic',
    price: 2500,
  },
];

export const shopService = {
  getShopItems: (): ShopItem[] => {
    return SHOP_ITEMS;
  },

  getItemById: (itemId: string): ShopItem | undefined => {
    return SHOP_ITEMS.find(item => item.id === itemId);
  },

  getItemsByType: (type: string): ShopItem[] => {
    return SHOP_ITEMS.filter(item => item.type === type);
  },
};

